import * as React from 'react';
import { ScreeningToolType } from '../types/ScreeningTool';
import { APIContext } from './ScreeningToolResponse';
import Button from 'components/Button';
import RadioButton from 'components/RadioButton';

const SelectScreeningTool: React.FC<{ screeningTools: ScreeningToolType[] }> = ({ screeningTools }) => {
  const [screeningTool, setScreeningTool] = React.useState<ScreeningToolType | null>(null);
  const api = React.useContext(APIContext);

  return (
    <div className="relative min-h-[300px]">
      <h2 className="text-xl font-semibold mb-4">Which health concern would you like to focus on today?</h2>
      <form>
        <div className="flex flex-col gap-3">
          {screeningTools.map((tool) => (
            <RadioButton
              key={tool.id}
              name="screening_tool"
              value={tool.id}
              checked={screeningTool?.id === tool.id}
              onChange={() => setScreeningTool(tool)}
              onContainerClick={() => setScreeningTool(tool)}
            >
              <span className="font-medium text-gray-800 ml-3">{tool.health_concern_type}</span>
            </RadioButton>
          ))}
        </div>
      </form>
      <div className="mt-6 mb-12 flex justify-end">
        <Button
          variant="primary"
          disabled={!screeningTool}
          onClick={() => {
            if (screeningTool) {
              api.setCurrentScreeningTool(screeningTool);
            }
          }}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
export default SelectScreeningTool;
